/* Dozzee — global behaviour: header, menu, language, cookies, colour store, notify forms,
   cart add (sell mode) and motion bootstrap. Section scripts build on window.Dozzee. */
(function () {
  var D = (window.Dozzee = window.Dozzee || {});
  var S = D.settings || {};
  D.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  D.$ = function (s, r) { return (r || document).querySelector(s); };
  D.$$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  D.lsGet = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
  D.lsSet = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
  D.validEmail = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim()); };

  /* Run cb(gsap, ScrollTrigger, SplitText) once GSAP is loaded and fonts are ready. */
  D.gsap = function (cb) {
    var n = 0;
    (function wait() {
      if (window.gsap && window.ScrollTrigger && window.SplitText) {
        window.gsap.registerPlugin(window.ScrollTrigger, window.SplitText);
        var fonts = document.fonts ? Promise.race([document.fonts.ready, new Promise(function (r) { setTimeout(r, 2000); })]) : Promise.resolve();
        fonts.then(function () { cb(window.gsap, window.ScrollTrigger, window.SplitText); });
        return;
      }
      if (n++ < 150) setTimeout(wait, 60);
    })();
  };

  /* ---------- colours ---------- */
  D.colours = D.colours || [];
  D.colourBy = function (k) {
    k = String(k || '').toLowerCase();
    for (var i = 0; i < D.colours.length; i++) {
      var c = D.colours[i];
      if (c.key === k || c.name.toLowerCase() === k) return c;
    }
    return null;
  };
  D.getColour = function () {
    return D.colourBy(D.lsGet('dozzee.colour')) || D.colourBy(S.startColour) || D.colours[0];
  };
  /* Persist + broadcast. Listeners: document.addEventListener('dozzee:colour', e => e.detail) */
  D.setColour = function (k, source) {
    var c = D.colourBy(k);
    if (!c) return null;
    D.lsSet('dozzee.colour', c.name);
    document.dispatchEvent(new CustomEvent('dozzee:colour', { detail: { colour: c, source: source || null } }));
    return c;
  };
  D.tagFor = function (c) { return 'notify-' + c.name.toLowerCase().replace(/\s+/g, '-'); };

  /* ---------- notify forms ---------- */
  D.setNotifyTags = function (wrap, tags) {
    var inp = wrap && wrap.querySelector('[data-notify-tags]');
    if (inp) inp.value = Array.isArray(tags) ? tags.join(',') : tags;
  };
  D.resetNotify = function (wrap) {
    if (!wrap) return;
    wrap.classList.remove('is-done');
    var f = wrap.querySelector('form'), d = wrap.querySelector('[data-notify-done]'), er = wrap.querySelector('[data-notify-error]');
    if (f) f.hidden = false;
    if (d) d.hidden = true;
    if (er) er.hidden = true;
  };
  function showDone(wrap, email) {
    var f = wrap.querySelector('form'), d = wrap.querySelector('[data-notify-done]');
    D.$$('[data-email]', wrap).forEach(function (el) { el.textContent = email; });
    if (f) f.hidden = true;
    if (d) d.hidden = false;
    wrap.classList.add('is-done');
  }
  function initNotify(wrap) {
    if (wrap._dz) return; wrap._dz = 1;
    var form = wrap.querySelector('form'), err = wrap.querySelector('[data-notify-error]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]'), email = input ? input.value.trim() : '';
      if (!D.validEmail(email)) {
        if (err) { err.textContent = (D.strings && D.strings.emailInvalid) || 'Please enter a valid email address.'; err.hidden = false; }
        if (input) input.focus();
        return;
      }
      if (err) err.hidden = true;
      var btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
      var tags = (form.querySelector('[data-notify-tags]') || {}).value || '';
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
        .then(function (r) {
          // Shopify spam protection: hand over to a real submit so the challenge page can show.
          if (/\/challenge/.test(r.url)) { form.submit(); return; }
          if (!r.ok) throw new Error(r.status);
          showDone(wrap, email);
          wrap.dispatchEvent(new CustomEvent('dozzee:notified', { bubbles: true, detail: { email: email, tags: tags } }));
        })
        .catch(function () {
          if (err) { err.textContent = (D.strings && D.strings.error) || 'Something went wrong.'; err.hidden = false; }
        })
        .then(function () { if (btn) btn.disabled = false; });
    });
  }
  D.initNotify = function (root) { D.$$('[data-notify]', root).forEach(initNotify); };

  /* ---------- add to cart (sell mode) ---------- */
  D.addToCart = function (variantId, qty) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) { if (!r.ok) throw r; return D.refreshCart(); });
  };
  D.refreshCart = function () {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { D.$$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); return c; });
  };

  /* ---------- header ---------- */
  function initHeader() {
    var header = D.$('[data-header]'), menu = D.$('[data-menu]');
    if (!header) return;

    // language dropdowns
    D.$$('[data-lang]').forEach(function (box) {
      var btn = box.querySelector('[data-lang-toggle]'), list = box.querySelector('[data-lang-menu]');
      if (!btn || !list) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = list.hidden;
        D.$$('[data-lang-menu]').forEach(function (m) { m.hidden = true; });
        D.$$('[data-lang-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        list.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-lang]')) return;
      D.$$('[data-lang-menu]').forEach(function (m) { m.hidden = true; });
      D.$$('[data-lang-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });

    // full-screen menu
    var openBtn = D.$('[data-menu-open]'), closeBtn = D.$('[data-menu-close]');
    function setMenu(open) {
      if (!menu) return;
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (D.lenis) open ? D.lenis.stop() : D.lenis.start();
      header.classList.remove('is-hidden');
      if (open && closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
    }
    if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); if (openBtn) openBtn.focus(); });
    if (menu) menu.addEventListener('click', function (e) { if (e.target.closest('nav a')) setMenu(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu && menu.classList.contains('is-open')) setMenu(false); });

    // hide on scroll down / show on scroll up (sub-pages)
    if (header.hasAttribute('data-autohide')) {
      var lastY = window.scrollY;
      window.addEventListener('scroll', function () {
        var y = window.scrollY, d = y - lastY;
        if (Math.abs(d) < 6) return;
        var hide = d > 0 && y > 240 && !(menu && menu.classList.contains('is-open'));
        header.classList.toggle('is-hidden', hide);
        lastY = y;
      }, { passive: true });
    }
  }

  /* ---------- cookies ---------- */
  function initCookies() {
    var card = D.$('[data-cookies]');
    if (!card) return;
    if (!D.lsGet('dozzee.cookies')) card.hidden = false;
    function set(v) {
      D.lsSet('dozzee.cookies', v);
      card.hidden = true;
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      var apply = function () {
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(
            v === 'all' ? { analytics: true, marketing: true, preferences: true, sale_of_data: true }
                        : { analytics: false, marketing: false, preferences: false, sale_of_data: false },
            function () {});
        } catch (e) {}
      };
      if (cp) apply();
      else if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (er) { if (!er) apply(); });
      }
    }
    var a = card.querySelector('[data-cookies-accept]'), es = card.querySelector('[data-cookies-essential]');
    if (a) a.addEventListener('click', function () { set('all'); });
    if (es) es.addEventListener('click', function () { set('essential'); });
  }

  /* ---------- motion ---------- */
  function initMotion() {
    if (!window.DozzeeMotion) return;
    var root = D.$('.dz-root') || document.body;
    // Expose Lenis to section scripts once created by dozzee-motion.js.
    D._stopMotion = window.DozzeeMotion.init(root, { smooth: !!S.smooth });
    var tries = 0;
    (function grab() {
      if (window.__dzLenis) { D.lenis = window.__dzLenis; return; }
      if (tries++ < 100) setTimeout(grab, 100);
    })();
  }

  function boot() {
    initHeader();
    initCookies();
    D.initNotify(document);
    initMotion();
    document.addEventListener('shopify:section:load', function (e) {
      D.initNotify(e.target);
      if (window.ScrollTrigger) setTimeout(function () { window.ScrollTrigger.refresh(); }, 100);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
